export default ["en", "fi", "de", "fr", "es", "id", "pt", "nl"]
